export default {"src":"/_next/static/media/account-shape2.d498df37.svg","height":20,"width":19,"blurWidth":0,"blurHeight":0};